import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createReportIssue,
  getIdReportIssue,
  getActivity,
  updateReportIssue,
  getActivityDetail,
} from "./activityAPI";

const initialState = {
  data: [],
  data2: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchActivity = createAsyncThunk(
  "Activity/fetchActivity",
  async (payload) => {
    const response = await getActivity(payload);
    return response;
  }
);

export const fetchActivityDetail = createAsyncThunk(
  "Activity/fetchActivityDetail",
  async (payload) => {
    const response = await getActivityDetail(payload);
    return response;
  }
);

export const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchActivityDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActivityDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      });
  },
});

export const { resetData, setSelected } = activitySlice.actions;

export const selectActivity = (state) => state.activity.data;
export const selectActivityDetail = (state) => state.activity.data2;
export const selectIdReportIssue = (state) => state.activity.dataId;
export const selectLoading = (state) => state.activity.loading;
export const selectError = (state) => state.activity.error;
export const selectPageNo = (state) => state.activity.pageNo;
export const selectPageSize = (state) => state.activity.pageSize;
export const selectTotalRecord = (state) => state.activity.totalRecord;
export const selectSelected = (state) => state.activity.selected;
export const selectResult = (state) => state.activity.result;

export default activitySlice.reducer;
